import React, { useState } from 'react';
import '../../assets/styles/imageTextSection.scss';

export type ImageTextSectionProps = {
  image: string;
  imageAlt?: string;
  title: string;
  description: string;
  fullDescription?: string;
  buttonText?: string;
  imagePosition?: 'left' | 'right';
  backgroundColor?: string;
  titleColor?: string;
  buttonColor?: string;
};

const ImageTextSection: React.FC<ImageTextSectionProps> = ({
  image,
  imageAlt = '',
  title,
  description,
  fullDescription,
  buttonText,
  imagePosition = 'left',
  backgroundColor = '#fff',
  titleColor = '#d06bcc',
  buttonColor = '#9c27b0',
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const styleVars = {
    '--its-bg': backgroundColor,
    '--its-title-color': titleColor,
    '--its-button-color': buttonColor,
  } as React.CSSProperties;

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <section className="image-text-section" style={styleVars}>
      <div className="its-container">
        <div className={`its-content ${imagePosition === 'right' ? 'reverse' : ''}`}>
          <div className={`its-image ${isExpanded ? 'expanded' : ''}`}>
            <img src={image} alt={imageAlt} loading="lazy" />
          </div>
          <div className="its-text">
            <h2 className="its-title">{title}</h2>
            <p className={`its-description ${isExpanded ? 'expanded' : ''}`}>
              {isExpanded && fullDescription ? fullDescription : description}
            </p>
            {buttonText && fullDescription && (
              <button onClick={handleToggle} className="its-button">
                {isExpanded ? 'Daha Az Göster' : buttonText}
                <svg 
                  width="20" 
                  height="20" 
                  viewBox="0 0 20 20" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ transform: isExpanded ? 'rotate(-90deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}
                >
                  <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImageTextSection;
